const roles = {
    ['volunteer']: {
        pageTickets: true,
        pageUsers: true,
        pageAccessRights: true,
        pageOrg: false,
        search: true,
        makeOrder: true,
        menu: true,
        userCard: true,
        pageCounter: false,
        pageEvents: false,
        editEventContactPerson: false,
    },
    ['crm_administrator']: {
        pageCounter: true,
        pageEvents: true,
        pageAccessRights: true,
        pageOrg: true,
        searchCounter: true,
        counterCard: true,
        changeRoleManager: true,
        changeLinkingCounter: true,
        changeLinkingEvents: true,
        menu: true,
        addCounter: true,
        pageTickets: true,
        pageUsers: true,
        editEventContactPerson: true,
    },
    ['crm_manager']: {
        pageCounter: true,
        pageEvents: true,
        pageAccessRights: true,
        pageOrg: true,
        addCounter: true,
        pageTickets: false,
        pageUsers: false,
        changeRoleManager: false,
        changeLinkingCounter: false,
        changeLinkingEvents: false,
        editEventContactPerson: false,
    },
    ['editor']: {
        editorAccess: false,
    }

}

export const getRolesAccess = (rolesString = '') => {
    const rolesList = rolesString.split(',').map(role => role.trim());
    let combinedRights = {};

    if (Array.isArray(rolesList)) {
        rolesList.forEach(role => {
            if (roles[role]) {
                Object.keys(roles[role]).forEach(key => {
                    if (roles[role][key] === true) {
                        combinedRights[key] = true;
                    } else if (combinedRights[key] !== true) {
                        combinedRights[key] = false;
                    }
                });
            }
        });
    }

    return combinedRights;
}

